<template>
  <page-outline :title="listTitle">
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <!-- Bouton de rafraîchissement -->
        <b-row class="justify-content-start">
          <b-col cols="6" lg="3" xl="2" class="mb-5">
            <b-button class="btnFilter"
              @click="displayFilter = !displayFilter">
              <i v-if="displayFilter" class="fa-light fa-minus"></i>
              <i v-else class="fa-light fa-plus"></i>
              {{ $t('filter.fltr') }}
            </b-button>
          </b-col>
          <b-col cols="6" lg="3" xl="2" class="mb-5">
            <b-button
              class="btnFilter"
              :disabled="activateSpinner"
              @click="onRefresh()">
              <i class="fa-light fa-rotate-right fs-14px"></i>
            {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
          <b-col cols="6" lg="6" xl="4" class="mb-5">
            <b-button variant="primary"
              @click="actionAdd">
              <i class="fa-light fa-plus"></i>
              <span>{{$t('common.alerts.alert_configuration_add')}}</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row class="justify-content-start align-items-center" :class="{'filter-item-section':true, 'd-none': !displayFilter}">
          <!-- Filtre MetricsKey -->
          <b-col sm="3" class="form-group">
            <label for="metrickey">
              {{ $t('common.alerts.metrics_key') }}
            </label>
            <select class="form-control" v-model="IdMetricsKey" id="metrickey">
              <option value="" disabled selected>{{ $t('common.alerts.select_metrics_key') }}</option>
              <option v-for="metricsKey in metricsKeyList" :key="metricsKey.id" :value="metricsKey.id">
                {{ $t('common.monitoring.key.' + metricsKey.text) }}
              </option>
            </select>
          </b-col>
          <!-- Filtre EmailGroupName -->
<!--          <b-col sm="3" class="form-group">-->
<!--            <label for="email-group">-->
<!--              {{ $t('common.email.group_name') }}-->
<!--            </label>-->
<!--            <select class="form-control" v-model="IdEmailGroupName" id="email-group">-->
<!--              <option v-for="emailGroup in emailGroupList" :key="emailGroup.id" :value="emailGroup.id">-->
<!--                {{ emailGroup.text }}-->
<!--              </option>-->
<!--            </select>-->
<!--          </b-col>-->
        </b-row>

        <b-row class="justify-content-end" v-if="displayFilter">
          <!-- Boutons Effacer et Appliquer -->
          <b-col sm="4" lg="2" cols="12" class="mt-4 mb-5">
            <b-button class="mr-3" size="sm"
                      @click="clearFilterFields" :disabled="activateSpinner">
              {{ $t('filter.clr_fltr_field') }}
            </b-button>
          </b-col>
          <b-col sm="4" lg="2" cols="12" class="mt-4 mb-5">
            <b-button class="btn" size="sm"
                      @click="onRefresh">
              {{ $t('common.srch') }}
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mb-5">
          <b-col cols="12">
            <div style="overflow:auto">
              <spinner v-if="activateSpinner"></spinner>
              <b-table v-else-if="listItemsAlerts.length > 0"
                :items="listItemsAlerts"
                :fields="fields"
                class="table-striped"
                hover
                :selectable="listItemsAlerts.length > 0"
                :empty-text="$t('common.security.no_result')"
                style="margin-bottom:0"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDir"
                @head-clicked="sortTable"
                @row-selected="onRowClicked"
                :key="refreshKey">
                <template #cell(MetricsKey)="data">
                  <span>{{ $t('common.monitoring.key.' + data.value) }}</span>
                </template>
                <template #cell(ThresholdHigh)="data">
                  <span>{{ data.value }}</span>
                </template>
                <template #cell(ThresholdLow)="data">
                  <span>{{ data.value }}</span>
                </template>
                <template #cell(ThresholdUnit)="data">
                  <span>{{ data.value }}</span>
                </template>
                <template #cell(UpdatedAt)="data">
                  <span>{{ getDate(data.value) }}</span>
                </template>
                <template #cell(EmailGroupName)="data">
                  <span>{{ data.value }}</span>
                </template>
                <template #cell(Criticality)="data">
                  <span>{{ mapCriticalityToAlert(data.value) }}</span>
                </template>
                <template #cell(edit)="data">
                  <span class="text-center d-inline-block py-3 w-100" @click="actionEdit($event, data.item.IdAlerts)">
                    <i class="fa-regular fa-pencil"></i>
                  </span>
                </template>
                <template #cell(delete)="data">
                  <span class="text-center d-inline-block py-3 w-100" @click="actionDelete($event, data.item.IdAlerts)">
                    <i class="fa-regular fa-trash"></i>
                  </span>
                </template>
              </b-table>
              <div v-else class="d-flex justify-content-center">
                <span class="noResult">
                  {{ $t('common.no_result') }}
                </span>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col>
            <cm-pagination
              :maxResultsByPage="paginationObject.maxResults"
              :firstIndex="paginationObject.firstIndex"
              :nbResultsTotal="paginationObject.nbResultsTotal"
              :refreshEvent="paginationObject.refresh">
            </cm-pagination>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import Pagination from '@/components/common/pagination.vue'
import moment from 'moment'
import PageOutline from "@/components/common/PageOutline.vue"
import Spinner from "@/components/common/spinner.vue"
import { errorMessageAlert } from "@/helpers/alert"
import { loadPage } from "@/helpers/routing"

export default {
  name: "AlertsPage",
  components: {
    'cm-pagination': Pagination,
    "form-write-group-label-input": formWriteGroupLabelInput,
    "page-outline": PageOutline,
    spinner: Spinner
  },
  props: {
    id: {
      type: String,
      default: "-1",
    },
  },
  data() {
    return {
      activateSpinner: false,
      displayFilter: false,
      elementSearchedEmailGroup: '',
      elementSearchedMetricsKey: '',
      emailGroupList: [],
      filterConditions: {},
      IdEmailGroupName: '',
      listItemsAlerts: [],
      listTitle: "",
      IdMetricsKey: '',
      metricsKeyList: [],
      pageCounter: 0,
      paginationObject: {},
      refreshKey: false,
      sortBy: '',
      sortDir: false
    }
  },
  created() {
    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
    }

    this.listTitle = this.$i18n.t("common.alerts.alert_configuration")
    this.activateSpinner = true

    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.getAlerts(index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0

    this.getAlerts()
    // desactiver pour lot 1
    // this.getEmailGroups()
    this.getMetricsKey()

    if (this.id !== "-1") {
      this.tabName = parseInt(this.id)
    }
  },
  computed: {
    canDelete () {
      return true
    },
    canEdit () {
      return true
    },
    fields () {
      let fields = []
      fields.push({
        key: 'Name',
        label: this.$t('common.alerts.name'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'MetricsKey',
        label: this.$t('common.alerts.metrics_key'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'ThresholdUnit',
        label: this.$t('common.alerts.threshold_unit'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'ThresholdLow',
        label: this.$t('common.alerts.threshold_low'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'ThresholdHigh',
        label: this.$t('common.alerts.threshold_high'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'UpdatedAt',
        label: this.$t('common.alerts.updated_at'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center p-2 py-3',
        sortable: true
      })
      // fields.push({
      //   key: 'EmailGroupName',
      //   label: this.$t('common.email.group_name'),
      //   thClass: 'text-center table-condensed-ipad',
      //   tdClass: 'p-0 text-center w-100 p-2 py-3',
      //   sortable: true
      // })
      fields.push({
        key: 'Criticality',
        label: this.$t('common.alerts.criticality_level'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center p-2 py-3',
        sortable: true
      })
      if (this.canEdit) {
        fields.push({ key: 'edit', label: this.$t('rights.edit'), thClass: 'text-center table-condensed-ipad', tdClass: 'p-0', sortable: false })
      }
      if (this.canDelete) {
        fields.push({ key: 'delete', label: this.$t('rights.delete'), thClass: 'text-center table-condensed-ipad', tdClass: 'p-0', sortable: false })
      }
      return fields
    }
  },
  methods: {
    actionAdd () {
      loadPage(this, {url: '/alerts/add/-1'})
    },
    actionDelete ($e, id) {
      $e.stopPropagation()
      let that = this
      this.$f7.modal({
        title: this.$t('common.alerts.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = { id: id }
              that.$engine.alerts.delete(params)
              .then(resp => {
                that.listItemsAlerts = that.listItemsAlerts.filter(item => item.IdAlerts !== id)
                that.$f7.modal({
                  title: that.$t('common.alerts.alert_configuration_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                // loadPage(that, { url: '/alerts/' + emailGroupId })
                loadPage(that, { url: '/alerts/' })
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.alerts.alert_configuration_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () { return }
          }
        ]
      })
    },
    actionEdit ($e, id) {
      $e.stopPropagation()
      loadPage(this, { url: '/alerts/edit/' + id })
    },
    applyFilter(filterConditions = {}) {
      this.filterConditions = filterConditions

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.getAlerts()
    },
    clearFilterFields() {
      this.IdEmailGroupName = ''
      this.IdMetricsKey = ''
      // this.applyFilter()
    },
    getAlerts(index = 1) {
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0
      let that = this
      let params = {
        IdMetricsKey: this.IdMetricsKey,
        IdEmailGroupName: this.IdEmailGroupName,
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex
      }
      if (this.filterConditions.OrderByField) {
        params.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        params.OrderByDirection = this.filterConditions.OrderByDirection
      }
      this.$engine.alerts.fetch(params).then((resp) => {
        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        that.paginationObject.nbResults = resp.data.Alerts.length

        let alertsList = {}

        alertsList = resp.data.Alerts

        that.updateAlerts(alertsList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getDate (date) {
      if (date != ''){
        return moment.utc(date).local().format('DD/MM/YYYY HH:mm:ss')
      }
      else {
        return '-'
      }
    },
    getEmailGroups() {
      let params = { name: this.elementSearchedEmailGroup }
      let that = this
      this.$engine.email.emailGroup.fetch(params).then((resp) => {
        this.emailGroupList = resp.data.EmailGroup.map(group => ({
          id: group.IdEmailGroup,
          text: group.GroupName,
          value: group.GroupName
        }))
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getMetricsKey() {
      let params = { name: this.elementSearchedMetricsKey }
      let that = this
      this.$engine.monitoring.metricsKey.fetch(params).then((resp) => {
        const uniqueMetricsKey = new Set()
        this.metricsKeyList = resp.data.MetricsKey.filter((metricsKey) => {
          const isUnique = !uniqueMetricsKey.has(metricsKey.IdMetricsKey)
          uniqueMetricsKey.add(metricsKey.IdMetricsKey)
          return isUnique
        }).map((metricsKey) => ({
          id: metricsKey.IdMetricsKey,
          text: metricsKey.MetricsKey,
          value: metricsKey.MetricsKey
        })).sort((a, b) => a.text.localeCompare(b.text))
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    mapCriticalityToAlert(criticality) {
      if (criticality === '') {
        return ''
      }
      switch (Number(criticality)) {
        case 0:
          return this.$t('common.alerts.low')
        case 1:
          return this.$t('common.alerts.medium')
        case 2:
          return this.$t('common.alerts.high')
        case 3:
          return this.$t('common.alerts.critical')
        default:
          return ''
      }
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    onRefresh() {
      this.refreshKey = !this.refreshKey
      this.activateSpinner = true
      this.getAlerts()
    },
    onRowClicked(item) {
      if (item[0] && item[0].IdAlerts) {
        loadPage(this, { url: '/alerts/details/' + item[0].IdAlerts })
      }
    },
    sortTable (key, field, event, isFooter) {
      const sortableFields = [
        'Name',
        'MetricsKey',
        'ThresholdUnit',
        'ThresholdLow',
        'ThresholdHigh',
        'UpdatedAt',
        'Criticality'
      ]

      if (!sortableFields.includes(key)) {
        return
      }

      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection

      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    updateAlerts(alertsList) {
      this.listItemsAlerts = alertsList
    },
    viewEmailSender() {
      loadPage(this, { url: '/email/emailSender/-1' })
    },
  }
}
</script>

<style scoped>

@media (max-width: 1400px) {
  .responsive-button {
    min-height: 70px;
  }
}
</style>
